var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MTableCell',[_c('div',{staticClass:"m-table-cell-text text text--xs",style:({color: _vm.textColor})},[_c('span',[_vm._v(_vm._s(_vm.itemText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }